// Shared style helper for the launcher's injected DOM.

/**
 * Apply inline styles with `!important` priority.
 *
 * The widget injects all of its layout styles inline (see domInjector header)
 * so the host page's CSS "can't corrupt the layout" — but a *plain* inline
 * style still LOSES to a host rule marked `!important`. Real hosts ship those:
 * AdminLTE/Bootstrap layouts (e.g. `body.layout-fixed`) carry global
 * `!important` positioning rules that hijacked our fullscreen overlay,
 * shifting it ~90px right / 124px up so it no longer covered the viewport.
 *
 * Marking the layout-critical properties `!important` is what actually
 * delivers the isolation the inline-styles strategy promises. `setProperty`
 * needs kebab-case names, so camelCase keys are converted on the way in.
 */
export function setImportant(el: HTMLElement, styles: Record<string, string>): void {
  for (const [prop, value] of Object.entries(styles)) {
    const name = prop.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
    el.style.setProperty(name, value, 'important');
  }
}
